module.exports = __webpack_public_path__ + "img/3.de3370fa.jpg";